import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { CalendarHeadingProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { CalendarHeading, useForwardProps } from "reka-ui"
import { cn } from "@/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarHeading',
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props



const delegatedProps = reactiveOmit(props, "class")

const forwardedProps = useForwardProps(delegatedProps)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CalendarHeading), _mergeProps({
    "data-slot": "calendar-heading",
    class: _unref(cn)('text-sm font-medium', props.class)
  }, _unref(forwardedProps)), {
    default: _withCtx(({ headingValue }) => [
      _renderSlot(_ctx.$slots, "default", { headingValue: headingValue }, () => [
        _createTextVNode(_toDisplayString(headingValue), 1)
      ])
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})